export default "__VITE_ASSET__BKtIR_kf__"